<p-drawer
  [visible]="visible"
  position="right"
  [style]="{ width: '680px', maxWidth: '100vw' }"
  [showCloseIcon]="false"
  [dismissible]="false"
  [closeOnEscape]="false"
  [modal]="true"
  styleClass="periodo-renovacao-drawer"
>
  <div class="drawer-header">
    <div class="heading">
      <span class="title">Novo Período de Renovação</span>
      <span class="description"
        >Defina o ano lectivo, o tipo de bolsa e o intervalo de renovação.</span
      >
    </div>
    <p-button
      icon="pi pi-times"
      [rounded]="true"
      [text]="true"
      severity="secondary"
      [disabled]="loading"
      (onClick)="requestClose()"
    />
  </div>

  <form [formGroup]="form" class="drawer-form">
    <div class="field field-full">
      <label for="anoLectivo"
        >Ano Lectivo <span aria-hidden="true">*</span></label
      >
      <p-calendar
        inputId="anoLectivo"
        class="w-full"
        styleClass="w-full"
        formControlName="anoLectivo"
        view="year"
        dateFormat="yy"
        placeholder="Selecione o ano lectivo"
        [showIcon]="true"
        [readonlyInput]="true"
        [minDate]="minAnoLectivoDate"
        [maxDate]="maxAnoLectivoDate"
        appendTo="body"
      ></p-calendar>
      <small class="field-hint"
        >O calendário apresenta os anos lectivos disponíveis.</small
      >
      <small
        class="error-message"
        *ngIf="
          form.get('anoLectivo')?.touched &&
          form.get('anoLectivo')?.errors?.['required']
        "
      >
        Ano lectivo é obrigatório.
      </small>
      <small
        class="error-message"
        *ngIf="
          form.get('anoLectivo')?.touched &&
          form.get('anoLectivo')?.errors?.['anoLectivoInvalido']
        "
      >
        Selecione um ano lectivo disponível.
      </small>
    </div>

    <div class="field field-full">
      <label for="tipoBolsaEnum"
        >Tipo de Bolsa <span aria-hidden="true">*</span></label
      >
      <p-select
        inputId="tipoBolsaEnum"
        class="w-full"
        styleClass="w-full"
        [options]="tipoBolsaOptions"
        optionLabel="label"
        optionValue="value"
        formControlName="tipoBolsaEnum"
        placeholder="Selecione o tipo de bolsa"
        appendTo="body"
      ></p-select>
      <small
        class="error-message"
        *ngIf="
          form.get('tipoBolsaEnum')?.touched &&
          form.get('tipoBolsaEnum')?.errors?.['required']
        "
      >
        Tipo de bolsa é obrigatório.
      </small>
    </div>

    <div class="date-fields">
      <div class="field">
        <label for="dataInicio"
          >Data Início <span aria-hidden="true">*</span></label
        >
        <p-calendar
          inputId="dataInicio"
          class="w-full"
          styleClass="w-full"
          formControlName="dataInicio"
          dateFormat="dd/mm/yy"
          placeholder="dd/mm/aaaa"
          [showIcon]="true"
          appendTo="body"
        ></p-calendar>
        <small
          class="error-message"
          *ngIf="
            form.get('dataInicio')?.touched &&
            form.get('dataInicio')?.errors?.['required']
          "
        >
          Data de início é obrigatória.
        </small>
      </div>

      <div class="field">
        <label for="dataFim">Data Fim <span aria-hidden="true">*</span></label>
        <p-calendar
          inputId="dataFim"
          class="w-full"
          styleClass="w-full"
          formControlName="dataFim"
          dateFormat="dd/mm/yy"
          placeholder="dd/mm/aaaa"
          [showIcon]="true"
          [minDate]="form.get('dataInicio')?.value"
          appendTo="body"
        ></p-calendar>
        <small
          class="error-message"
          *ngIf="
            form.get('dataFim')?.touched &&
            form.get('dataFim')?.errors?.['required']
          "
        >
          Data de fim é obrigatória.
        </small>
        <small
          class="error-message"
          *ngIf="
            form.get('dataFim')?.touched &&
            form.errors?.['dataFimAntesDataInicio']
          "
        >
          A data de fim deve ser igual ou posterior à data de início.
        </small>
      </div>
    </div>
  </form>

  <div class="drawer-footer">
    <p-button
      label="Cancelar"
      severity="secondary"
      [outlined]="true"
      [disabled]="loading"
      (onClick)="requestClose()"
    ></p-button>
    <p-button
      label="Guardar"
      [loading]="loading"
      [disabled]="form.invalid || loading"
      (onClick)="submit()"
    ></p-button>
  </div>
</p-drawer>

<p-confirmdialog></p-confirmdialog>
